import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="tc-header-preview tc-header-preview--split">
      <div className="container-fluid tc-header-split">
        <div className="tc-header-split__content">
          <div className="tc-header-split__eyebrow text-uppercase">
            Premium Interior & PVC Decor Solutions
          </div>

          <h1 className="tc-header-split__title">
            Premium <span className="accent">Interiors</span>
            <br />
            Made Easy
          </h1>

          <p className="tc-header-split__subtitle">
            PVC panels, wall coverings, ceilings & modern finishes — from
            selection to installation.
          </p>

          <div className="tc-header-split__actions">
            <Link
              to="/contact"
              className="butn bg-orange1 text-white rounded-pill"
            >
              <span>Get a Quote</span>
            </Link>
            <Link to="/collection" className="butn butn-outline rounded-pill">
              <span>View Collection</span>
            </Link>
          </div>

          <div className="tc-header-split__chips">
            <span className="chip">Authorized Delby Distributor</span>
            <span className="chip">On-site measurement</span>
            <span className="chip">Fast delivery</span>
          </div>
        </div>

        <div className="tc-header-split__media" aria-hidden="true">
          <img
            src="/home_preview/assets/img/header4.jpg"
            alt=""
            className="img-cover"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />

          <div className="tc-header-split__facts">
            <div className="label text-uppercase">The facts</div>
            <div className="facts-row">
              <div className="fact">
                <div className="num">95%</div>
                <div className="txt">Clients satisfied</div>
              </div>
              <div className="fact">
                <div className="num">4000</div>
                <div className="txt">Projects done</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
